import {AgencyRepositoryType} from "../../interfaces/repositories/AgencyRepositoryType.ts";

export class DeleteAgencyPackageUseCase {
    constructor(private readonly agencyRepository: AgencyRepositoryType) {}

    execute(agencyId: string, packageId: string): Promise<void> {
        return this.agencyRepository.deleteAgencyPackage(agencyId, packageId)
    }
}

